import { render, staticRenderFns } from "./CartGroup.vue?vue&type=template&id=6c80ce07&"
import script from "./CartGroup.vue?vue&type=script&lang=js&"
export * from "./CartGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports